import { useState } from 'react';
import { ReactComponent as ArrowUpIcon } from '../../../assets/arrow_up.svg';
import { ReactComponent as ArrowDownIcon } from '../../../assets/arrow_down.svg';
import sortIcon from '../../../assets/sorting.svg';

export enum SortOption {
  CREATED_NEW_TO_OLD = 'created_new_to_old',
  CREATED_OLD_TO_NEW = 'created_old_to_new',
  UPDATED_NEW_TO_OLD = 'updated_new_to_old',
  UPDATED_OLD_TO_NEW = 'updated_old_to_new',
}

export const SORT_OPTIONS = [
  { value: SortOption.UPDATED_NEW_TO_OLD, label: 'Updated Date - New to Old' },
  { value: SortOption.UPDATED_OLD_TO_NEW, label: 'Updated Date - Old to New' },
  { value: SortOption.CREATED_NEW_TO_OLD, label: 'Created Date - New to Old' },
  { value: SortOption.CREATED_OLD_TO_NEW, label: 'Created Date - Old to New' },
];

const SortDropdown = ({
  selectedSort,
  setSelectedSort,
}: {
  selectedSort: SortOption;
  setSelectedSort: (sort: SortOption) => void;
}) => {
  const [listOpened, setListOpened] = useState(false);

  const updateSort = (sortOption: SortOption) => {
    setSelectedSort(sortOption);
    setListOpened(false);
  };

  const getSelectedLabel = () => {
    return SORT_OPTIONS.find(option => option.value === selectedSort)?.label || '';
  };

  return (
    <div
      tabIndex={1}
      onClick={() => setListOpened(true)}
      onBlur={() => setListOpened(false)}
      style={{
        ...{
          position: 'relative',
          width: '100%',
          display: 'flex',
          flexDirection: 'row' as 'row',
          alignItems: 'center',
        },
        ...styles.select,
      }}
    >
      <img src={sortIcon} alt="sort" style={{ width: '2.4vh', height: '2.4vh', marginRight: '0.8vh' }} />
      {getSelectedLabel()}
      <div style={{ flex: 1 }}></div>
      {listOpened ? (
        <ArrowUpIcon style={{ width: '2.4vh', height: '2.4vh', color: 'rgba(16, 29, 59, 0.6)' }} />
      ) : (
        <ArrowDownIcon style={{ width: '2.4vh', height: '2.4vh', color: 'rgba(16, 29, 59, 0.6)' }} />
      )}

      {listOpened && (
        <div style={{ ...styles.dropdown }}>
          {SORT_OPTIONS.filter(option => option.value !== selectedSort).map(option => (
            <div
              key={option.value}
              style={styles.option}
              onMouseDown={e => {
                updateSort(option.value);
                e.stopPropagation();
              }} // Use onMouseDown to prevent blur before click
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  select: {
    padding: '1.4vh 1.6vh',
    borderRadius: '1.6vh',
    border: '0.1vh solid rgba(16, 29, 59, 0.1)',
    backgroundColor: '#ffffff',
    color: '#101D3B',
    cursor: 'pointer',
    transition: 'border-color 0.2s',
    outline: 'none',
    width: '44.4vh',
    boxSizing: 'border-box' as 'border-box',
    fontWeight: '400',
    fontSize: '1.4vh',
  },
  dropdown: {
    position: 'absolute' as 'absolute',
    padding: '0vh 1.6vh',
    top: 'calc(100% - 0.6vh)', // Position it right below the input
    left: '0',
    width: 'calc(100% - 3.2vh)', //compensate padding
    borderTop: 'none',
    maxHeight: '15vh',
    overflowY: 'auto' as 'auto',
    backgroundColor: '#ffffff',
    zIndex: 1,
    borderRadius: '1.6vh',
    boxShadow: '0vh 0.8vh 3.2vh -0.4vh rgba(16, 29, 59, 0.1)',
  },
  option: {
    padding: '0.8vh 0vh',
    fontWeight: '400',
    fontSize: '1.4vh',
    cursor: 'pointer',
    borderBottom: '0.1vh solid #eee',
    color: '#2d3436',
    textAlign: 'left' as 'left',
    height: '3.2vh',
    display: 'flex',
    alignItems: 'center',
  },
};

export default SortDropdown;
